<template>
 <div class="main">
  <router-view></router-view>
  <!-- <div class="content" v-if="$route.path=='/home/setting'">
    <div class="show" @click="toRoute">
    <img src="../../assets/images/tiger.png" alt="" srcset="">
    <el-button type="primary" icon="el-icon-right">进入管理</el-button>
  </div>
  </div> -->
  
 </div>
</template>

<script>
export default {
  name: 'FinanceReport',
  methods: {
    toRoute(){
      this.$router.push('/home/setting/tradePair')
    }
  },
};
</script>

<style lang="less" scoped>
  .main{
    margin-top: 0;
    padding: 0;
    height: 100%;
  }
  .content{
    width: 100%;
    height: 100%;
    // background-color: pink;
    border: none;
    border-radius:10px;
    // box-shadow: 0px 0px 3px 0px;
    background-color: rgba(235, 241, 243, 0.2);
  }
  .show{
    width: 300px;
    height: 300px;
    // background-color: aqua;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    padding-top: 100px ;
    margin:0 auto;
  }
</style>
